<template>
    <div class="page-user-wrap">
        <div class="inner">
            <pageBreadcrumb :option="nav_option" />
            <div class="page-ctx">
                <div class="user-left">
                    <div class="nav-wrap">
                        <div class="itemNav">
                            <div class="parentItem" @click="goMyIndex">
                                <div class="itemLeft">
                                    <img src="../../assets/img/mine/mineIcon1.png" class="mineIcon1" alt="" />
                                    <div class="leftText" :class="{ active: !!(activeRoute == '/my-index') }">会员中心首页</div>
                                </div>
                            </div>
                            <div class="line"></div>
                            <div class="parentItem" @click="navSwitch(1)">
                                <div class="itemLeft">
                                    <img src="../../assets/img/mine/mineIcon2.png" class="mineIcon2" alt="" />
                                    <div class="leftText">订单管理</div>
                                </div>
                                <img src="../../assets/img/mine/selectIcon.png" class="goIcon" alt="" />
                            </div>
                            <div v-show="showList[0]">
                                <div class="height15"></div>
                                <div class="childrenItem" @click="goPage(0)" :class="{ active: !!(activeRoute == '/order-list') }">标准鼓订单</div>
                                <div class="height15"></div>
                                <div class="childrenItem" @click="goPage(1)" :class="{ active: !!(activeRoute == '/order-list2') }">定制鼓订单</div>
                                <div class="height15"></div>
                                <div class="childrenItem" @click="goPage(2)" :class="{ active: !!(activeRoute == '/refund-list') }">我的售后</div>
                            </div>
                            <div class="line"></div>
                            <div class="parentItem" @click="navSwitch(2)">
                                <div class="itemLeft">
                                    <img src="../../assets/img/mine/mineIcon2.png" class="mineIcon2" alt="" />
                                    <div class="leftText">我的活动</div>
                                </div>
                                <img src="../../assets/img/mine/selectIcon.png" class="goIcon" alt="" />
                            </div>
                            <div v-show="showList[1]">
                                <div class="height15"></div>
                                <div class="childrenItem" @click="goPage(3)" :class="{ active: !!(activeRoute == '/favorite-list') }">我的收藏</div>
                                <div class="height15"></div>
                                <div class="childrenItem" @click="goPage(4)" :class="{ active: !!(activeRoute == '/browse-history') }">浏览足迹</div>
                            </div>
                            <div class="line"></div>
                            <div class="parentItem" @click="navSwitch(3)">
                                <div class="itemLeft">
                                    <img src="../../assets/img/mine/mineIcon2.png" class="mineIcon2" alt="" />
                                    <div class="leftText">个人资料</div>
                                </div>
                                <img src="../../assets/img/mine/selectIcon.png" class="goIcon" alt="" />
                            </div>
                            <div v-show="showList[2]">
                                <div class="height15"></div>
                                <div class="childrenItem" @click="goPage(5)" :class="{ active: !!(activeRoute == '/address-list') }">地址管理</div>
                                <div class="height15"></div>
                                <div class="childrenItem" @click="goPage(6)" :class="{ active: !!(activeRoute == '/invoice-list') }">我的发票</div>
                                <div class="height15"></div>
                                <div class="childrenItem" @click="goPage(7)" :class="{ active: !!(activeRoute == '/my-info') }">个人信息</div>
                                <div class="height15"></div>
                                <div class="childrenItem" @click="goPage(8)" :class="{ active: !!(activeRoute == '/change-password') }">修改密码</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="user-right">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { SHOP_TYPE } from '@/config/env.js'

import pageBreadcrumb from '@/components/page/page-breadcrumb.vue'

import { mapState } from 'vuex'

export default {
    name: 'my',
    components: {
        pageBreadcrumb,
    },
    data() {
        return {
            //个人中心导航
            userMenu: [
                {
                    title: '会员中心',
                    route: 'my-index',
                    is_main: true,
                },
                // {
                //   title: "会员中心",
                //   route: "my-index",
                // },

                {
                    title: '订单中心',
                    route: '',
                },
                {
                    title: '我的订单',
                    route: 'order-list',
                },
                // {
                //   title: "我的售后",
                //   route: "refund-list",
                // },
                {
                    title: '评价晒单',
                    route: 'my-review-list',
                },

                // {
                //   title: "我的购物车",
                //   route: "cart",
                // },
                // {
                //   title: "我的售后",
                //   route: "refund-list",
                // },

                {
                    title: '我的活动',
                    route: '',
                },
                {
                    title: '我的收藏',
                    route: 'favorite-list',
                },
                {
                    title: '我的足迹',
                    route: 'browse-history',
                },

                {
                    title: '个人设置',
                    route: '',
                },
                {
                    title: '地址管理',
                    route: SHOP_TYPE == 'foreign' ? 'foreign-address-list' : 'address-list',
                },

                {
                    title: '个人资料',
                    route: 'my-info',
                },

                {
                    title: '修改密码',
                    route: 'change-password',
                },

                // {
                //   title: "意见反馈",
                //   route: "feedback",
                // },
                // {
                //   title: "我的优惠券",
                //   route: "myCoupon",
                // },
                // {
                //   title: "领券中心",
                //   route: "couponCenter",
                // },
                // {
                //   title: "账户资金",
                //   route: "",
                // },
                // {
                //   title: "我的佣金",
                //   route: "myCommission",
                // },
                // {
                //   title: "我的业绩",
                //   route: "myYeJi",
                // },

                // {
                //   title: "我的团队",
                //   route: "myTeam",
                // },
                // {
                //   title: "分润统计",
                //   route: "myFenRun",
                // },
                // {
                //   title: "在线充值",
                //   route: "yueChongzhi",
                // },
                // {
                //   title: "余额明细",
                //   route: "yueMingxi",
                // },
                // {
                //   title: "我的积分",
                //   route: "pointsDetail",
                // },
                // {
                //   title: "积分商城",
                //   route: "pointsMall",
                // },
            ],
            activeRoute: '',
            openeds: ['order-list'],
            showList: [true, true, true], // 左侧栏显示和隐藏
            nav_option: [
                { title: '个人中心', path: '/my-index' },
                { title: '首页', path: '' },
            ], // 面包屑二级导航栏
        }
    },
    computed: {
        filter_userMenu() {
            let navList = []
            navList = this.userMenu
            return navList
        },
    },

    //导航激活
    beforeRouteUpdate(to, from, next) {
        // console.log('组件复用 from', from)
        // console.log('组件复用 to', to)
        next()
    },
    watch: {
        $route: {
            immediate: true,
            handler(newV) {
                this.activeRoute = newV.path
                if (newV.meta.title == '会员中心') {
                    this.nav_option = [
                        { title: '个人中心', path: '/my-index' },
                        { title: '首页', path: '' },
                    ]
                } else {
                    this.nav_option = [
                        { title: '个人中心', path: '/my-index' },
                        { title: newV.meta.title, path: '/' },
                    ]
                }
            },
        },
    },
    created() {
        // this.subArr = this.subNavArr[0];
    },

    mounted() {},

    methods: {
        // 去页面
        goPage(type) {
            if (type == 0) {
                // 标准鼓订单
                this.$router.push({
                    path: '/order-list',
                })
            } else if (type == 1) {
                // 定制鼓订单
                this.$router.push({
                    path: '/order-list2',
                })
            } else if (type == 2) {
                // 我的售后
                this.$router.push({
                    path: '/refund-list',
                })
            } else if (type == 3) {
                // 我的收藏
                this.$router.push({
                    path: '/favorite-list',
                })
            } else if (type == 4) {
                // 浏览足迹
                this.$router.push({
                    path: '/browse-history',
                })
            } else if (type == 5) {
                // 地址管理
                this.$router.push({
                    path: '/address-list',
                })
            } else if (type == 6) {
                // 我的发票
                this.$router.push({
                    path: '/invoice-list',
                })
            } else if (type == 7) {
                // 个人信息
                this.$router.push({
                    path: '/my-info',
                })
            } else if (type == 8) {
                // 修改密码
                this.$router.push({
                    path: '/change-password',
                })
            }
        },
        // 去个人中心首页
        goMyIndex() {
            this.$router.push({
                path: '/my-index',
            })
        },
        // 菜单展开和收起
        navSwitch(type) {
            if (type == 1) {
                // 订单管理
                if (this.showList[0]) {
                    this.showList[0] = false
                } else {
                    this.showList[0] = true
                }
            } else if (type == 2) {
                // 我的活动
                if (this.showList[1]) {
                    this.showList[1] = false
                } else {
                    this.showList[1] = true
                }
            } else if (type == 3) {
                // 个人资料
                if (this.showList[2]) {
                    this.showList[2] = false
                } else {
                    this.showList[2] = true
                }
            }
            this.showList = this.$cloneDeep(this.showList)
        },
        do_toggle_nav(item) {
            if (!item.route) {
                // let route = item.sub[0].route;
                // this.$router.push("/" + route);
            } else {
                this.$router.push('/' + item.route)
            }
        },
    },
}
</script>

<style scoped lang="less">
.page-user-wrap {
    background: #f9fafc;
    padding-top: 58px;

    .inner {
        width: @width;
        margin: 0 auto;
        min-height: 70vh;

        .page-ctx {
            padding-top: 36px;
            display: flex;
            justify-content: space-between;
        }

        .user-left {
            width: 220px;
            min-width: 220px;
            margin-bottom: 50px;

            .nav-wrap {
                background: #f9f9f9;
                background: #fff;
                padding-bottom: 70px;
                padding-top: 22px;

                .itemNav {
                    width: 172px;
                    margin: 0 auto;
                    overflow: hidden;

                    .height15 {
                        width: 100%;
                        height: 18px;
                    }

                    .parentItem {
                        width: 100%;
                        overflow: hidden;
                        padding-left: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        cursor: pointer;

                        .itemLeft {
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .mineIcon1 {
                                width: 14px;
                                display: block;
                                margin-right: 10px;
                            }

                            .mineIcon2 {
                                width: 12px;
                                display: block;
                                margin-right: 10px;
                            }

                            .leftText {
                                font-size: 16px;
                                line-height: 16px;
                                color: #333333;
                            }

                            .leftText.active {
                                color: #ff5f00;
                            }
                        }
                    }

                    .childrenItem {
                        font-size: 14px;
                        line-height: 14px;
                        color: #666666;
                        padding-left: 34px;
                        cursor: pointer;
                    }

                    .childrenItem.active {
                        color: #ff5f00;
                    }

                    .line {
                        width: 100%;
                        height: 1px;
                        background: #f0f0f0;
                        margin: 15px 0;
                    }

                    .goIcon {
                        width: 14px;
                        display: block;
                    }
                }

                .nav-item {
                    width: 172px;
                    margin: 0 auto;
                    overflow: hidden;

                    .nav-title {
                        position: relative;
                        cursor: pointer;
                        text-align: left;
                        font-weight: 500;
                        font-size: 12px;
                        color: #808080;

                        &.link {
                            margin-bottom: 16px;

                            &:hover {
                                color: #4ca5e4;
                            }
                        }

                        &.main-title {
                            margin-bottom: 24px;
                            cursor: pointer;
                            user-select: none;
                            font-weight: 500;
                            font-size: 14px;
                            color: #333333;
                        }

                        &.active {
                            // background: #ffffff;
                            // background: #fffaf7;
                            color: #4ca5e4;

                            &:before {
                                // content: "";
                                // position: absolute;
                                // left: 0;
                                // top: 0;
                                // bottom: 0;
                                // width: 3px;
                                // background-color: #4CA5E4;
                            }
                        }

                        &[data-hide='hide'] {
                            display: none;
                        }
                    }

                    &:first-child {
                        .main-title {
                            margin-top: 0;
                        }
                    }
                }
            }
        }

        .user-right {
            flex: 2;
            margin-left: 35px;
            min-height: 50vh;
            padding-bottom: 50px;
        }
    }
}
</style>

<style scoped lang="less" src="@/assets/h5css/user/index.less"></style>
